import { Flex } from "antd";
import type { FC } from "react";
import { countText, isPointDistribution } from "tm-shared/utils";

import { PointCardBase } from "@/domains/point";
import BaseButton from "@/shared/ui/BaseButton";
import { BaseModal } from "@/shared/ui/BaseModal";
import { PrimaryText } from "@/shared/ui/Typography";
import { PointCreateModal, PointCreateModalPayloads } from "@/types/modals";

interface DuplicateByIdModalProps {
    onClose: () => void;
    payload: PointCreateModalPayloads[PointCreateModal.DuplicateById];
}

export const DuplicateByIdModal: FC<DuplicateByIdModalProps> = ({
    onClose,
    payload,
}) => {
    const { point, routeCount } = payload;

    const hasRoutes = routeCount > 0;

    const pointStatus = hasRoutes
        ? "hasRoutes"
        : point.market.isArchived
          ? "archived"
          : null;

    const externalId = isPointDistribution(point)
        ? point.typeContext.externalId
        : "";

    return (
        <BaseModal
            open
            onClose={onClose}
            mask={{ closable: false }}
            title={"Увага"}
            closable={false}
            actions={null}
        >
            <Flex vertical gap={24} style={{ minHeight: 0 }}>
                <PrimaryText fontSize={16}>
                    Торгова точка з ID {externalId} вже існує
                </PrimaryText>

                <PointCardBase
                    point={point}
                    isChild={false}
                    status={pointStatus}
                    slot={
                        hasRoutes && (
                            <PrimaryText textColor="error">
                                Ця ТТ знаходиться у{" "}
                                {countText.route(routeCount)}
                            </PrimaryText>
                        )
                    }
                />

                <BaseButton type="default" size="large" onClick={onClose}>
                    Ok
                </BaseButton>
            </Flex>
        </BaseModal>
    );
};
